<template>
  <div>
    <dialog-confirm ref="remove-rule">
      <div class="text-subtitle-1">
        {{ $t('route_plan_rule_ui.confirm_delete') }}
      </div>
    </dialog-confirm>
    <v-data-table
      condensed
      :headers="headers"
      :items="remoteData.items">
      <template #item.note="row">
        <span v-if="row.item.customer_id !== customerId">(Parent)</span>
        {{ row.item.note }}
      </template>
      <template #item.created="row">
        {{ Moment(row.item.created).format('LLL') }}
      </template>
      <template #item.description="row">
        {{ row.item.description }}
        <span v-if="showActions && row.item.op === 'regex'">{{ row.item.value }}</span>
      </template>

      <template #item.actions="row" v-if="showActions">
        <v-btn
          v-if="row.item.customer_id === customerId"
          icon
          small
          outlined
          color="danger"
          @click="deleteItem(row.item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          small
          outlined
          color="primary"
          :to="parentLink">
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>

</template>
<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import RemoteDataTableMixin from '@/components/mixins/RemoteDataTableMixin'
import DialogConfirm from '@/components/shared/DialogConfirm.vue'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import { debounce, isEmpty, map } from 'lodash'
import Moment from 'moment-timezone'
export default {
  name: 'RoutePlanRuleIndex',
  mixins: [CurrentUserMixin, RemoteDataTableMixin, ApiUtilitiesMixin],
  components: {
    DialogConfirm
  },
  props: {
    customerId: {
      required: true
    },
    parentId: {
      required: true
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: 'RoutePlanRule',
      searchCriteria: this.getDefaultSearchCriteria(),
      headers: [
        { text: this.$t('route_plan_rule_ui.description'), value: 'description' },
        { text: this.$t('route_plan_rule_ui.note'), value: 'note' },
        { text: this.$t('route_plan_rule_ui.created'), value: 'created' }
      ],
      loadRemoteDataDelayed: debounce(this.loadRemoteData, 500)
    }
  },
  computed: {
    parentLink () {
      return `/customer/${this.parentId}`
    },
    routePlanRuleCount () {
      return this.remoteData.totalItems
    }
  },
  methods: {
    refresh () {
      this.refreshResults()
    },
    Moment,
    getDefaultSearchCriteria () {
      return {
        customerId: this.customerId
      }
    },
    buildSearchCriteria () {
      const searchCriteria = {
        fields: 'id,name,description,note,customer_id,created,op,value',
        customer_id: this.customerId,
        parent_id: this.parentId,
        page: this.remoteData.currentPage,
        'per-page': this.remoteData.rowsPerPage
      }
      if (this.remoteData.sortBy !== null) {
        const sortDirection = this.remoteData.sortDesc ? '-' : ''
        searchCriteria.sort = `${sortDirection}${this.remoteData.sortBy}`
      }

      return searchCriteria
    },
    async deleteItem (item) {
      if (await this.$refs['remove-rule'].confirm()) {
        item.destroy()
          .then(resp => {
            this.refreshResults()
          })
          .catch(error => {
            if (error) {
              this.renderErrorModal(error)
              throw (error)
            }
          })
      }
    }
  },
  mounted () {
    if (this.showActions) {
      this.headers.push({ text: this.$tc('route_plan_rule_ui.action', 2), value: 'actions', sortable: false })
    }
  },
  created () {
    this.refreshResults()
  }
}
</script>
